<template>
    <div class="dynamic-content">
        <h1 class="page-title">Platform Disclaimer</h1>
        <p class="effective-date">Effective Date: September 05, 2025</p>

        <div class="content-section compact-section">
            <p class="section-title">1. Platform Role Disclaimer</p>
            <p class="desc-text">
                XigFor is an online platform that provides a marketplace for users to post content and buy or sell items. The platform does not participate in transactions between users and does not guarantee or endorse any user, product, or service. Users are solely responsible for verifying the
                credibility and legality of any transaction or content.
            </p>
        </div>

        <div class="content-section compact-section">
            <p class="section-title">2. User Content Disclaimer</p>
            <p class="desc-text bullet-text">All content posted by users, including but not limited to product descriptions, reviews, photos, videos, and profile information, is the responsibility of the user.</p>
            <p class="desc-text bullet-text">XigFor does not guarantee the accuracy, completeness, or authenticity of any user-posted content.</p>
            <p class="desc-text bullet-text">Users assume all risk when relying on content posted by others.</p>
        </div>

        <div class="content-section compact-section">
            <p class="section-title">3. Service Availability Disclaimer</p>
            <p class="desc-text bullet-text">XigFor does not guarantee uninterrupted, error-free, or continuous service.</p>
            <p class="desc-text bullet-text">The platform may modify, suspend, or terminate all or part of its services at any time without prior notice.</p>
            <p class="desc-text bullet-text">XigFor is not responsible for technical problems, maintenance, upgrades, or other issues that may interrupt service.</p>
        </div>

        <div class="content-section compact-section">
            <p class="section-title">4. Transaction & Third-Party Disclaimer</p>
            <p class="desc-text bullet-text">XigFor is not a party to disputes between users and does not mediate or guarantee outcomes.</p>
            <p class="desc-text bullet-text">Any issues arising from transactions, including payment, delivery, or refunds, must be resolved by the users involved.</p>
            <p class="desc-text bullet-text">The platform may integrate third-party services, including payment processors and logistics providers. XigFor is not responsible for any errors, delays, or losses caused by these third-party services.</p>
            <p class="desc-text bullet-text">Links to third-party websites are provided for convenience. Users access them at their own risk, and XigFor is not responsible for third-party content or privacy practices.</p>
        </div>

        <div class="content-section compact-section">
            <p class="section-title">5. Limitation of Liability</p>
            <p class="desc-text bullet-text">To the fullest extent permitted by law, XigFor shall not be liable for any of the following, whether in contract, tort, strict liability, or other legal theory:</p>
            <p class="desc-text bullet-text">Loss of profits, revenue, or data</p>
            <p class="desc-text bullet-text">Indirect, incidental, special, consequential, or punitive damages</p>
            <p class="desc-text bullet-text">Costs of procurement of substitute goods or services</p>
            <p class="desc-text bullet-text">Unauthorized access, alteration, or loss of data</p>
            <p class="desc-text bullet-text">User interactions or communications, including disputes or misconduct</p>
            <p class="desc-text bullet-text">Any matter related to the Services, whether foreseeable or not</p>
        </div>

        <div class="content-section compact-section">
            <p class="section-title">6. Force Majeure & Data Loss</p>
            <p class="desc-text bullet-text">XigFor is not responsible for service interruptions or user loss caused by force majeure events, including but not limited to natural disasters, wars, terrorist attacks, government actions, or cyber attacks.</p>
            <p class="desc-text bullet-text">XigFor strives to protect user data but does not guarantee against data loss or damage for any reason.</p>
        </div>

        <div class="content-section compact-section">
            <p class="section-title">7. User Acknowledgement</p>
            <p class="desc-text bullet-text">By using XigFor services, you acknowledge and agree that:</p>
            <p class="desc-text bullet-text">You understand the risks associated with using the platform.</p>
            <p class="desc-text bullet-text">You cannot hold XigFor responsible for any loss, damage, or dispute arising from your use of the platform or third-party services.</p>
            <p class="desc-text bullet-text">You accept these disclaimers as part of your agreement with XigFor.</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PlatformDisclaimer'
}
</script>

<style scoped>
@import '../info/shared-info-styles.css';

.dynamic-content {
    /* max-width: 760px; */
}

.page-title {
    margin-bottom: 6px;
    font-size: 40px;
    font-weight: 700;
    color: #393944;
}

.effective-date {
    font-size: 40px;
    font-weight: 700;
    color: #9B9CA5;
    margin-bottom: 18px;
    line-height: 1.5;
}

.compact-section {
    margin-bottom: 16px;
}

.section-title {
    font-family: 'Poppins Light', sans-serif;
    font-size: 26px;
    font-weight: 300;
    line-height: 56px;
    color: #6C6C78;
    margin-top: 0;
    margin-bottom: 8px;
}

.desc-text {
    font-family: 'Poppins Light', sans-serif;
    font-size: 26px;
    font-weight: 300;
    line-height: 56px;
    color: #6C6C78;
    margin-bottom: 4px;
}

.bullet-text {
    position: relative;
    padding-left: 12px;
}

.bullet-text::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0.72em;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background-color: currentColor;
}

@media (max-width: 900px) {
    .page-title {
        font-size: 20px;
        font-weight: 700;
        color: #393944;
        margin-bottom: 4px;
    }

    .effective-date {
        font-size: 12px;
        font-weight: 700;
        color: #9B9CA5;
        margin-bottom: 14px;
    }

    .section-title {
        font-family: 'Poppins Light', sans-serif;
        font-size: 10px;
        font-weight: 300;
        line-height: 20px;
        color: #6C6C78;
        margin-bottom: 6px;
        margin-top: 20px;
    }

    .desc-text {
        font-family: 'Poppins Light', sans-serif;
        font-size: 10px;
        font-weight: 300;
        line-height: 20px;
        color: #6C6C78;
        margin-bottom: 3px;
    }

    .bullet-text {
        padding-left: 10px;
    }

    .bullet-text::before {
        top: 0.7em;
        width: 3px;
        height: 3px;
    }

    .compact-section {
        margin-bottom: 14px;
    }
}
</style>
